import React, { useState, useEffect, useRef, useCallback } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ConsoleLog from '../../common/ConsoleLog';
import {  
    Row,
    Col,
    Button,
    Tooltip
} from 'reactstrap';
import axios from 'axios';
import StyledTableRow from './TableRowStyle';
import ModalConfirm from '../../common/ModalConfirm';
import { toast } from 'react-toastify';

const RowForTable = (props) => {
     
    const api_url = process.env.REACT_APP_SERVER_URL;
    const pdpBaseUrl = process.env.REACT_APP_PDP_LINK;
    const { row, showMSRP, showWholeSale, showMyPrice, showProjectTotal, user, canAddToCart, deleteProject, currency } = props;
    const [open, setOpen] = useState(false);
    const [totalQty, setTotalQty] = useState(0);
    const [totalPrice, setTotalPrice] = useState("0.00");
    const [tbdPrice ,setTBDPrice] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [openConfigs, setOpenConfigs] = useState({});
    const [configDetails, setConfigDetails] = useState({});
    const [loadingConfigDetailsById, setLoadingConfigDetailsById] = useState({});
    const [usersProject, setUsersProject] = useState(false);
    const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
    const [isExportingProject, setIsExportingProject] = useState(false);
    const [isAddingProjectToCart, setIsAddingProjectToCart] = useState(false);
    const [addingToCartByConfigId, setAddingToCartByConfigId] = useState({});
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
    const isCad = currency === 'CAD';

    const addCurrencyPrefix = (value) => {
        if (value == null) return value;
        const str = String(value);
        // Only prefix numeric-like strings (allowing digits, commas, decimal point)
        const numericLike = /^[\d,]+(\.\d+)?$/;
        
        return isCad && numericLike.test(str) ? `C$${str}` : `$${str}`;
    };

    const formatCurrencyDisplayValue = (value) => {
        if (value == null) return '';
        const str = String(value).trim();
        if (!str) return '';
        return addCurrencyPrefix(str.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    };

    const formatDateMMDDYYYY = (value) => {
        if (!value) return '';
        const date = new Date(value);
        if (isNaN(date.getTime())) return value;
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    };

    const toggleOpen = useCallback(() => {
        setOpen(prevOpen => !prevOpen);
    }, []);

    const toggleModalConfirm = useCallback(()=>{
        setConfirmDeleteModalOpen(prev => !prev);
    },[]);

    const handleDownloadProjectClick = useCallback(async ()=>{
        try{
            setIsExportingProject(true);
            await props.downloadProject(row.encProjectId || row.encryptedId);
        } finally {
            setIsExportingProject(false);
        }
    },[props.downloadProject, row.encProjectId, row.encryptedId]);

    
    useEffect(() => {
            //calculate visible qty and total price for current user. may be different than the overall qty and price for this project due to the private/public restriction
            let tempQty = 0;
            let tempTtl = 0.00;
            let tbdFound  = false;
            row.sessionConfigurations.map(pc => {
             
                if(!tbdFound && pc.netPrice ==="TBD")
                    tbdFound = true;
                if(user ===pc.createdBy || !pc.isPrivate)
                {
                    tempQty += pc.qty;
                    if(!tbdFound)
                        tempTtl += parseFloat(pc.netPrice);
                }
           });
           setTotalQty(tempQty);
           setTotalPrice( tbdFound ? "TBD" : tempTtl.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
           setTBDPrice(tbdFound);
           if(user && row)
             setUsersProject(user===row.createdBy);
    }, [row, user]);
    const handleAddProjectToCartClick = async (project) =>  {
        setIsAddingProjectToCart(true);
        try {
            let configIdsArray =[];
            //loop through configuration Id
            project.sessionConfigurations.map(config => {
                configIdsArray.push(config.idConfig);
            });
            
            let url = `${api_url}Product/GetProductConfigurationByIds/Clean`;
            let api_method = axios.post;
        
            const apiResponse = await api_method(url, configIdsArray, {
                headers: { 'Content-Type': 'application/json' },
            });

        
            if(apiResponse.data)
            {
                let optiConfigs = [];
                apiResponse.data.map(cleanConfig => {
                    var optiConfig = cleanConfig.sessionConfigurationDetails.map(({configDetailVariable,  answerText
                    }) => [configDetailVariable, answerText]);

                    optiConfigs.push({
                        "ConfigurationId" : cleanConfig.idConfig,
                        "ConfigurationOptions": optiConfig,
                        "Product_Id":cleanConfig.product.productId,
                        "Quantity":cleanConfig.qty 
                    });
                });
                var postMessage =  {
                    "Status": "Complete",
                    Configurations:optiConfigs
                }
                console.log("postMessage",postMessage);
                window.parent.postMessage(postMessage, "*");
            }
        } finally {
            setIsAddingProjectToCart(false);
        }
    }

    const handleAddToCartClick = async (configId) =>  {
        setAddingToCartByConfigId(prev => ({ ...prev, [configId]: true }));
        try {
            let url = `${api_url}Product/GetProductConfigurationById/${configId}/Clean`;
            let api_method = axios.get;

                const apiResponse = await api_method(url,  {
                    headers: { 'Content-Type': 'application/json' },
                });

                var optiConfig = apiResponse.data.sessionConfigurationDetails.filter(sd => sd.configDetailVariable !== "IV_CUST_CURRNCY" && sd.configDetailVariable !== "WAREHOUSE" && sd.configDetailVariable !== "PRODUCT_ID")
                .map(s => [s.configDetailVariable, s.answerText]);
    
                let optiConfigs = [];
                optiConfigs.push({
                    "ConfigurationId" : configId,
                    "ConfigurationOptions": optiConfig,
                    "Product_Id": apiResponse.data.product.productId,
                    "Quantity": apiResponse.data.qty 
                });
                var postMessage =  {
                    "Status": "Complete",
                    Configurations:optiConfigs
                }
                console.log("postMessage",postMessage);
                window.parent.postMessage(postMessage, "*");
        } finally {
            setAddingToCartByConfigId(prev => ({ ...prev, [configId]: false }));
        }
    }

    const handleBaseModelClick = async (baseModel, configId) => {
        // Toggle open state for this configuration
        setOpenConfigs(prev => ({
            ...prev,
            [configId]: !prev[configId]
        }));
        // If details not loaded yet, fetch them
        if (!configDetails[configId]) {
            try {
                setLoadingConfigDetailsById(prev => ({ ...prev, [configId]: true }));
                const url = `${api_url}Product/GetProductConfigurationById/${configId}/Clean`;
                const apiResponse = await axios.get(url, {
                    headers: { 'Content-Type': 'application/json' },
                });
                const optiConfig = apiResponse.data.sessionConfigurationDetails
                    .filter(sd => sd.configDetailVariable !== "IV_CUST_CURRNCY" && 
                                sd.configDetailVariable !== "WAREHOUSE" && 
                                sd.configDetailVariable !== "PRODUCT_ID")
                    .map(s => [s.configDetailVariable, s.answerText]);
                setConfigDetails(prev => ({
                    ...prev,
                    [configId]: optiConfig
                }));
            } catch (error) {
                console.error('Error fetching configuration details:', error);
            } finally {
                setLoadingConfigDetailsById(prev => ({ ...prev, [configId]: false }));
            }
        }
    };

    const normalizeDiscontinuedFlag = useCallback((value) => {
        // The API sometimes returns boolean-like values as strings/numbers.
        // We only treat explicit "yes/true/1" as discontinued; "no/false/0"/null is not.
        if (value === true) return true;
        if (value === false || value == null) return false;

        if (typeof value === 'number') {
            return value === 1;
        }

        if (typeof value === 'string') {
            const v = value.trim().toLowerCase();
            if (v === 'yes' || v === 'y' || v === 'true' || v === '1') return true;
            if (v === 'no' || v === 'n' || v === 'false' || v === '0' || v === '') return false;
            // Unknown string: default to NOT discontinued to avoid hiding links/actions erroneously.
            return false;
        }

        // Unknown type: default to NOT discontinued to avoid false positives.
        return false;
    }, []);

    const getPdpUrl = useCallback((modelOrSku) => {
        const model = (modelOrSku ?? '').toString().trim();
        if (!model) return null;
        if (!pdpBaseUrl) return null;
        return `${pdpBaseUrl}${encodeURIComponent(model)}`;
    }, [pdpBaseUrl]);

    const handleDeleteProject = async (encProjectId) =>{
        debugger;
        setConfirmDeleteModalOpen(false);
        if(!encProjectId){
            console.warn('encProjectId is missing for project delete. Check API response field name.');
            toast.error('Unable to delete: missing project identifier.');
            return;
        }
        deleteProject(encProjectId);
    }

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' }, '& .MuiTableCell-root': { fontSize: '13px' } }}>
                <TableCell sx={{"width": "4%"}} >
                <IconButton
                        aria-label='expand row'
                        size='small'
                        onClick={toggleOpen}
                    >
                        {open ? (
                            <KeyboardArrowUpIcon />
                        ) : (
                            <KeyboardArrowDownIcon />
                        )}
                    </IconButton>
                </TableCell>
                <TableCell component='th' scope='row' sx={{"width": "25%"}} >
                    <span className='thProjectTitle'> {row.projectName}</span>
                </TableCell>
                
                {(showProjectTotal ?? (showMSRP || showWholeSale || showMyPrice)) && (
                    <TableCell align='center' sx={{"width": "18%"}}>  
                    <ConsoleLog row={row}></ConsoleLog>
        
                        {showMSRP && !showWholeSale && !showMyPrice && (
                            <span>{formatCurrencyDisplayValue(row.msrp)}</span>
                        )} 
                        {showWholeSale && !showMyPrice && (
                            <span>{formatCurrencyDisplayValue(row.wholeSalePrice)}</span>
                        )} 
                        {showMyPrice && (
                            <span>{formatCurrencyDisplayValue(row.price)}</span>
                        )}
                       
                        {
                            tbdPrice && ( 
                                <>
                                 <span id={`projectprice_${row.id}`} className='tooltipIcon'> 
                                <i className="info">i</i>
                                </span>
                            <Tooltip
                                placement="right"
                                isOpen={tooltipOpen}
                                target={`projectprice_${row.id}`}
                                toggle={toggleTooltip}
                                >
                                Your custom configuration request has been emailed to the James Engineering Team for review, pricing and approval.
                                </Tooltip>
                                </>
                               )
                        }
                   
                    </TableCell>
                )}
                <TableCell align='center' sx={{"width": "7%"}} >{totalQty}</TableCell>
                <TableCell sx={{"width": "5%"}} >
                    {' '}
                    <input
                        type='text'
                        defaultValue={row.status}
                        onBlur={(e) => {
                            props.updateProjectStatus(row, e.target.value);
                        }}
                        style={{ border: ' 1px solid #dadada', padding: '4px 5px' }}
                         
                    />
                </TableCell>
                <TableCell sx={{"width": "15%"}} >{new Date(row.dateCreated).toLocaleDateString()} by {row.createdBy}</TableCell>
               <TableCell sx={{"width": "39%"}} >
                    <div className='project-actions'>
                    {(!tbdPrice && canAddToCart) && (
                        
                         <Button
                            className='btn-custom'
                            color='primary'
                            disabled={isAddingProjectToCart}
                            onClick={() => handleAddProjectToCartClick(row)}
                        >
                            {isAddingProjectToCart ? (
                                <CircularProgress size={16} thickness={5} sx={{ color: '#fff' }} />
                            ) : (
                                'Add Project to Cart'
                            )}
                        </Button> 
                         
                       
                    )}

                            {isExportingProject ? (
                                <div
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 27,
                                        height: 27,
                                        borderRadius: 0,
                                        backgroundColor: 'rgb(2, 157, 57)',
                                        verticalAlign: 'middle',
                                        marginRight: '5px'
                                    }}
                                    title='Exporting...'
                                >
                                    <CircularProgress size={16} thickness={5} sx={{ color: '#fff' }} />
                                </div>
                            ) : (
                                <IconButton
                                    aria-label='Export Project to Excel'
                                    title='Export Project to Excel'
                                    size='small'
                                    onClick={handleDownloadProjectClick}
                                    sx={{
                                        color: '#fff',
                                        backgroundColor: 'rgb(2, 157, 57)',
                                        borderRadius: 0,
                                        width: 27,
                                        height: 27,
                                        '&:hover': { backgroundColor: 'rgb(2, 120, 44)' }
                                    }}
                                >
                                    <span className='bi bi-file-earmark-excel-fill' style={{ fontSize: '16px' }}></span>
                                </IconButton>
                            )}

                    {usersProject && (
                        <>
                            <IconButton
                                aria-label='Delete Project'
                                title='Delete Project'
                                size='small'
                                onClick={toggleModalConfirm}
                                sx={{
                                    color: '#fff',
                                    backgroundColor: '#e84C3D',
                                    borderRadius: 0,
                                    width: 27,
                                    height: 27,
                                    '&:hover': { backgroundColor: '#bd3b31' }
                                }}
                            >
                                <DeleteForeverIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                            <ModalConfirm
                                open={confirmDeleteModalOpen}
                                close={toggleModalConfirm}
                                onConfirmClick={handleDeleteProject}
                                idProject={row.id}
                                encProjectId={row.encProjectId || row.encryptedId}
                            />

                            
                        </>
                        )}
                </div>
                    
                    
               </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={7}
                >
                    <Collapse in={open} timeout='auto' unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Table size='small' aria-label='purchases' className='config-table'>
                                <TableHead>
                                    <StyledTableRow>
                                        <TableCell sx={{"width": "10%"}} >User</TableCell>
                                        <TableCell sx={{"width": "10%"}} >SKU</TableCell>    
                                        <TableCell align='center' sx={{"width": "20%"}} >Price When Configured  </TableCell>
                                        <TableCell align='center' sx={{"width": "5%"}}>Qty</TableCell>
                                        <TableCell align='center' sx={{"width": "10%"}} >Net Price</TableCell>
                                        <TableCell align='left' sx={{"width": "12%"}} >Project Zone</TableCell>
                                        <TableCell align='center' sx={{"width": "10%"}} >Your Status</TableCell>
                                       
                                        <TableCell  align='center' sx={{"width": "23%"}} >
                                            Action
                                        </TableCell>
                                         
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {row.sessionConfigurations.map(
                                        (historyRow, idx) => {
                                            const isDiscontinued = normalizeDiscontinuedFlag(historyRow.discontinued);
                                            const replacementSku = (historyRow.replacementModel ?? '').toString().trim();
                                            const hasReplacementSku = replacementSku.length > 0;
                                            const replacementIsDiscontinued = hasReplacementSku && replacementSku.toLowerCase().includes('discontinued');
                                            const hasActiveReplacement = hasReplacementSku && !replacementIsDiscontinued;

                                            const baseModel = (historyRow.baseModel ?? '').toString();
                                            const description = (historyRow.description ?? '').toString();
                                            const showDescription = description.trim().length > 0;
                                            const primaryText = showDescription ? description : baseModel;

                                            const canDelete = (usersProject || user === historyRow.createdBy);

                                            // Case D (active SKU): not discontinued and no replacement SKU.
                                            const skuIsActive = !isDiscontinued && !hasReplacementSku;
                                            const baseModelUrl = skuIsActive ? getPdpUrl(baseModel) : null;
                                            const replacementUrl = hasActiveReplacement ? getPdpUrl(replacementSku) : null;

                                            return (
                                            <React.Fragment key={historyRow.idConfig}>
                                            <StyledTableRow sx={
                                                openConfigs[historyRow.idConfig]
                                                    ? {
                                                        border: '2px solid #1266d8',
                                                        borderBottom: '1px solid #dadada',
                                                        backgroundColor: '#ffffff',
                                                        '&:nth-of-type(odd)': { backgroundColor: '#ffffff' },
                                                        '& .MuiTableCell-root': { fontSize: '12px' },
                                                        '& .MuiTableCell-root *': { fontSize: '12px' },
                                                        '& td, & th': { borderBottom: 'none' }
                                                    }
                                                    : {
                                                        backgroundColor: (idx % 2 === 0 ? '#ffffff' : '#f5f5f5'),
                                                        '&:nth-of-type(odd)': { backgroundColor: (idx % 2 === 0 ? '#ffffff' : '#f5f5f5') },
                                                        '& .MuiTableCell-root': { fontSize: '12px' },
                                                        '& .MuiTableCell-root *': { fontSize: '12px' }
                                                    }
                                            }>
                                               
                                                <TableCell>
                                                    <div>{historyRow.createdBy} 
                                                        
                                                         
                                                    </div>
                                                </TableCell>
                                                <TableCell sx={{ maxWidth: 260 }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <span style={{ display: 'inline-flex', alignItems: 'flex-start', gap: '6px' }}>
                                                            <IconButton
                                                                aria-label={openConfigs[historyRow.idConfig] ? 'Collapse' : 'Expand'}
                                                                title={openConfigs[historyRow.idConfig] ? 'Collapse details' : 'Expand details'}
                                                                size='small'
                                                                onClick={() => handleBaseModelClick(historyRow.baseModel, historyRow.idConfig)}
                                                                sx={{ p: 0 }}
                                                            >
                                                                {openConfigs[historyRow.idConfig] ? (
                                                                    <KeyboardArrowUpIcon style={{ fontSize: '16px' }} />
                                                                ) : (
                                                                    <KeyboardArrowDownIcon style={{ fontSize: '16px' }} />
                                                                )}
                                                            </IconButton>
                                                            <span style={{ display: 'inline-block', maxWidth: '240px', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-word', lineHeight: 1.15 }}>
                                                                {skuIsActive && baseModelUrl ? (
                                                                    <a href={baseModelUrl} target="_parent" rel="noreferrer">
                                                                        {primaryText}
                                                                    </a>
                                                                ) : (
                                                                    primaryText
                                                                )}
                                                            </span>
                                                        </span>
                                                        {isDiscontinued && (
                                                            <span style={{ marginLeft: '22px', fontSize: '11px', color: '#e84C3D', padding: '1px 0px', display: 'inline-block', fontWeight: 'bold' }}>
                                                                [Discontinued]
                                                            </span>
                                                        )}
                                                    </div>
                                                </TableCell>
                                                
                                                <TableCell align='center'>
                                                   {
                                                        showMSRP && (
                                                        <Row>
                                                            <Col md='7'  align="right">
                                                            <b
                                                            style={{
                                                                color: 'rgb(0, 0, 0)',
                                                                fontSize:
                                                                    '12px',
                                                            }}
                                                        >
                                                            MSRP:
                                                            </b>
                                                            </Col>
                                                            <Col md='5' align='left'>
                                                                {addCurrencyPrefix(`${parseFloat(historyRow.msrp).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`)}   
                                                            </Col>
                                                        </Row>

                                                        )
                                                    } 
                                                    {
                                                        showWholeSale && (
                                                        <Row>
                                                            <Col md='7' align="right">
                                                            <b
                                                            style={{
                                                                color: 'rgb(0, 0, 0)',
                                                                fontSize:
                                                                    '12px',
                                                            }}
                                                        >
                                                            WHOLESALE:
                                                            </b>
                                                            </Col>
                                                            <Col md='5' align='left'>
                                                                {addCurrencyPrefix(`${parseFloat(historyRow.wholeSalePrice).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`)}                                                               
                                                            </Col>
                                                        </Row>

                                                        )
                                                    }  

                                                    {
                                                        showMyPrice && (
                                                            <>
                                                             <Row>
                                                            <Col md='7' align="right">
                                                            <b
                                                            style={{
                                                                color: '#007DAB',
                                                                fontSize:
                                                                    '12px',
                                                            }}
                                                        >
                                                            
                                                            CONFIGURED: 
                                                            </b>
                                                            </Col>
                                                            <Col md='5' align='left'>
                                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '2px', whiteSpace: 'nowrap' }}>
                                                                    {
                                                                        historyRow.price !== "TBD" ?
                                                                        addCurrencyPrefix(`${parseFloat(historyRow.price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`)
                                                                        :
                                                                        historyRow.price
                                                                    }
                                                                    
                                                                </span>
                                                            </Col>

                                                        </Row>
                                                        
                                                            </>
                                                       

                                                        )
                                                    }
                                                    {showMyPrice && 1==2 && (
                                                        <>
                                                        <Row>
                                                         
                                                        <Col md='7' align="right">
                                                            <b
                                                            style={{
                                                                color: 'rgb(24, 187, 156)',
                                                                fontSize:
                                                                    '12px',
                                                            }}
                                                        >
                                                            MY CONFIGURED PRICE: 
                                                            </b>
                                                            </Col>
                                                            <Col md='5' align='left'>
                                                            {addCurrencyPrefix(`${parseFloat(historyRow.basePrice).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`)}  
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col align='middle' md='12'>
                                                            <span
                                                            style={{
                                                                color: '#000000',
                                                                fontSize:
                                                                    '11px',
                                                            }}
                                                        >
                                                            
                                                           PRICED ON {formatDateMMDDYYYY(historyRow.dateModified)} 
                                                            </span>
                                                            </Col>
                                                            </Row>
                                                        </>
                                                    )}
                                                    <Row>
                                                          <Col align='middle' md='12'>
                                                            <span
                                                            style={{
                                                                color: '#000000',
                                                                fontSize:
                                                                    '11px',
                                                            }}
                                                        >
                                                            
                                                           PRICED ON {formatDateMMDDYYYY(historyRow.dateModified)} 
                                                            </span>
                                                            </Col>
                                                            </Row>
                                                   
                                                </TableCell>
                                                <TableCell align='center'>
                                                    {historyRow.qty}
                                                </TableCell>
                                                <TableCell align='center'>
                                                {
                                                    historyRow.netPrice !== "TBD" ?
                                                    addCurrencyPrefix(`${parseFloat(historyRow.netPrice).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`)
                                                    :
                                                    historyRow.netPrice
                                                }
                                              
                                                </TableCell>
                                                <TableCell>
                                                    {historyRow.title}
                                                </TableCell>
                                                <TableCell align='center'>
                                                    <input
                                                        type='text'
                                                        defaultValue={
                                                            historyRow.status
                                                        }
                                                        onBlur={(e) => {
                                                            props.updateStatus(
                                                                historyRow,
                                                                e.target.value
                                                            );
                                                        }}
                                                        style={{ border:'1px solid #dadada', padding:'5px', borderRadius:'5px' }}
                                                    />
                                                </TableCell>
                                                
                                                
                                                <TableCell align='center'>
                                                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px', flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>
                                                  {/* Case B/C: replacement SKU exists and is not the sentinel DISCONTINUED */}
                                                  {hasActiveReplacement && replacementUrl && (
                                                      <Button
                                                          className='btn-custom ml-2 add-to-cart-icon'
                                                          color='primary'
                                                          title={`View Replacement for ${baseModel}`}
                                                          tag='a'
                                                          href={replacementUrl}
                                                          target='_parent'
                                                          rel='noreferrer'
                                                      >
                                                          VIEW REPLACEMENT
                                                      </Button>
                                                  )}

                                                  {/* Case D: active SKU (no replacement, not discontinued) */}
                                                  {skuIsActive && (
                                                      <>
                                                          <Button
                                                              className='btn-custom ml-2 add-to-cart-icon'
                                                              color='primary'
                                                              disabled={!!addingToCartByConfigId[historyRow.idConfig]}
                                                              onClick={(e) =>
                                                                  handleAddToCartClick(historyRow.idConfig)
                                                              }
                                                          >
                                                              {!!addingToCartByConfigId[historyRow.idConfig] ? (
                                                                  <CircularProgress size={16} thickness={5} sx={{ color: '#fff' }} />
                                                              ) : (
                                                                  'Add to Cart'
                                                              )}
                                                          </Button>
                                                          {(usersProject || user === historyRow.createdBy) && (
                                                              <Button
                                                                  title='Edit Configuration'
                                                                  className='btn-custom ml-2 edit-icon'
                                                                  onClick={() => props.editRecord(historyRow)}
                                                              >
                                                                  <EditIcon sx={{ fontSize: 16 }} />
                                                              </Button>
                                                          )}
                                                          <Button
                                                              title='Copy Configuration'
                                                              className='btn-clone ml-2 copy-icon'
                                                              onClick={() => props.cloneRecord(historyRow)}
                                                          >
                                                              <ContentCopyIcon sx={{ fontSize: 16 }} />
                                                          </Button>
                                                      </>
                                                  )}
                                                 
                                                     
                                                    {canDelete && (
                                                        <IconButton
                                                        className='btn ml-2 delete-icon'
                                                        aria-label='Delete Item from Project'
                                                        title='Delete Item from Project'
                                                        size='small'
                                                        onClick={(e) =>
                                                            props.trashRecord(historyRow.idConfig)
                                                        }
                                                        sx={{
                                                            color: '#fff',
                                                            backgroundColor: '#e84C3D',
                                                            borderRadius: 0,
                                                            width: 27,
                                                            height: 27,
                                                            '&:hover': { backgroundColor: '#bd3b31' }
                                                        }}
                                                    >
                                                        <DeleteForeverIcon sx={{ fontSize: 16 }} />
                                                    </IconButton>

                                                    )}
                                                    
                                                  </div>
                                                </TableCell>
                                            </StyledTableRow>
                                            {openConfigs[historyRow.idConfig] && (
                                                <StyledTableRow sx={{ border: '2px solid #1266d8', borderTop: '0px', backgroundColor: '#f5f5f5', '& .MuiTableCell-root': { fontSize: '12px' }, '& .MuiTableCell-root *': { fontSize: '12px' } }}>
                                                    {/* Config details span first two columns (User + SKU) */}
                                                    <TableCell colSpan={2} align='left' sx={{ verticalAlign: 'top', p: 1.5 }}>
                                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '6px', padding: '6px' }}>
                                                            <strong style={{ display: 'block', marginBottom: '6px' }}><u>Configuration Details</u></strong>
                                                            {(loadingConfigDetailsById[historyRow.idConfig] || (openConfigs[historyRow.idConfig] && configDetails[historyRow.idConfig] === undefined)) ? (
                                                                <span>Loading Configuration Details for this SKU</span>
                                                            ) : (
                                                                <>
                                                                    {configDetails[historyRow.idConfig] && configDetails[historyRow.idConfig].length > 0 ? (
                                                                        configDetails[historyRow.idConfig].map(([variable, value], index) => (
                                                                            <div key={index} style={{ display: 'flex', justifyContent: 'space-between', gap: '8px' }}>
                                                                                <strong>{variable}</strong>
                                                                                <span style={{ textAlign: 'right' }}>{value}</span>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <span>No configuration details available.</span>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </TableCell>
                                              
                                                    {/* Pricing details span the next two columns (Price + Net Price) */}
                                                    <TableCell colSpan={2} align='left' sx={{ verticalAlign: 'top', p: 1.5 }}>
                                                        {(() => {
                                                            var src = [];
                                                            debugger;
                                                            if(props.pricingFlag === '1,1,1')
                                                                src = historyRow.upcharges;
                                                            else if(props.pricingFlag === '1,1,0')
                                                                src = historyRow.upcharges_Wholesale;
                                                        
                                                            else if(props.pricingFlag === '1,0,0')
                                                                src = historyRow.upcharges_MSRP;
                                                            const normalized = (
                                                                typeof src === 'string'
                                                                    ? src.split('|')
                                                                    : src
                                                            )?.map((entry) => {
                                                                if (!entry) return null;
                                                                if (typeof entry === 'string') {
                                                                    const parts = entry.split(':');
                                                                    const description = (parts[0] || '').trim();
                                                                    const amount = (parts[1] || '').trim();
                                                                    if (!description && !amount) return null;
                                                                    return { description, amount };
                                                                }
                                                                if (entry && (entry.description !== undefined || entry.upcharge !== undefined)) {
                                                                    return {
                                                                        description: (entry.description ?? '').toString(),
                                                                        amount: (entry.upcharge ?? '').toString()
                                                                    };
                                                                }
                                                                return null;
                                                            }).filter(Boolean);
                                                            if (!normalized || normalized.length === 0) return <span>No pricing details.</span>;
                                                            return (
                                                                <div style={{ backgroundColor: '#f5f5f5', padding: '6px', borderRadius: '4px' }}>
                                                                    <strong style={{ display: 'block', marginBottom: '6px' }}><u>Pricing Details</u></strong>
                                                                    {normalized.map((up, idx) => (
                                                                        <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                                                            <strong>{up.description}</strong>
                                                                            <span>
                                                                                {(() => {
                                                                                    const num = Number(up.amount);
                                                                                    const amt = isNaN(num)
                                                                                        ? up.amount
                                                                                        : num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                                                    return addCurrencyPrefix(amt);
                                                                                })()}
                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            );
                                                        })()}
                                                    </TableCell>
                                                    {/* Remaining columns: Project Zone, Your Status, Action */}
                                                    <TableCell />
                                                          {/* Placeholder for Qty column */}
                                                          <TableCell />
                                                    <TableCell />
                                                    <TableCell />
                                                </StyledTableRow>
                                            )}
                                          
                                            
                                            </React.Fragment>
                                        );
                                        }
                                    )}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
};
export default RowForTable;
